import { CognitoService } from './service'

export const userPoolId = process.env.GATSBY_COGNITO_USER_POOL_ID || ``
export const clientId = process.env.GATSBY_COGNITO_CLIENT_ID || ``
export const Cognito = new CognitoService(userPoolId, clientId)
